import { TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../../app/hooks";
import { SalaryType } from "../../../../orders/types/salaryType";

type Props = {
  baseComponentCodes: string[];
  personalComponentCodes: string[];
  extraComponentCodes: string[];
  salaryType: SalaryType;
};

const SalaryTableHeaders = ({
  baseComponentCodes,
  personalComponentCodes,
  extraComponentCodes,
  salaryType,
}: Props) => {
  const { t } = useTranslation();
  const { salaryComponent: translations } = useAppSelector(
    (state) => state.localized,
  );
  const isHourlySalary = salaryType === SalaryType.Hourly;

  const topHeaderStyles = {
    borderBottom: "none",
    borderTop: "none",
    padding: "0px 8px",
  };

  const headerStyles = {
    fontSize: "12px",
    padding: "0px 8px",
    borderBottom: "none",
    verticalAlign: "bottom",
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell sx={topHeaderStyles} />
        <TableCell sx={topHeaderStyles} />
        <TableCell
          sx={{
            border: "1px solid #00000061",
            ...topHeaderStyles,
          }}
          align="center"
          colSpan={baseComponentCodes.length}
        />
        {!!personalComponentCodes.length && (
          <TableCell
            sx={{
              border: !!extraComponentCodes.length
                ? "1px solid #00000061"
                : "none",
              ...topHeaderStyles,
            }}
            align="center"
            colSpan={personalComponentCodes.length}
          >
            <Typography variant="secondary" fontSize="12px">
              {t("talentProfile:personalSalaryComponentsLabel")}
            </Typography>
          </TableCell>
        )}
        {!!extraComponentCodes.length && (
          <TableCell
            sx={topHeaderStyles}
            align="center"
            colSpan={extraComponentCodes.length}
          >
            <Typography variant="secondary" fontSize="12px">
              {t("common:others")}
            </Typography>
          </TableCell>
        )}
      </TableRow>
      <TableRow>
        <TableCell width="120px" sx={headerStyles}>
          {t("common:start")}
        </TableCell>
        <TableCell width="120px" sx={headerStyles}>
          {isHourlySalary
            ? t("talentProfile:hourlyWork")
            : t("talentProfile:totalSalary")}
        </TableCell>
        {baseComponentCodes.map((header, index, array) => (
          <TableCell
            lang="fi"
            width="120px"
            key={header}
            sx={{
              borderLeft: index === 0 ? "1px solid #00000061" : "none",
              borderRight:
                index === array.length - 1 ? "1px solid #00000061" : "none",
              hyphens: "auto",
              ...headerStyles,
            }}
          >
            {translations[header] || header}
          </TableCell>
        ))}
        {personalComponentCodes.map((header, index, array) => (
          <TableCell
            lang="fi"
            key={header}
            width="120px"
            sx={{
              borderLeft: index === 0 ? "1px solid #00000061" : "none",
              borderRight:
                index === array.length - 1 && !!extraComponentCodes.length
                  ? "1px solid #00000061"
                  : "none",
              hyphens: "auto",
              ...headerStyles,
            }}
          >
            {translations[header] || header}
          </TableCell>
        ))}
        {extraComponentCodes.map((header) => (
          <TableCell
            key={header}
            width="120px"
            sx={{
              hyphens: "auto",
              ...headerStyles,
            }}
          >
            {translations[header] || header}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default SalaryTableHeaders;
